import React from 'react';
import { statusBadge } from './statusTone';
import './StatusBadge.css';

/**
 * A status pill from the shared map (PR 7b), or any { label, tone, pulse } badge.
 * @param {Object} props
 * @param {string} [props.status]   a league / tournament / drop-in / match / registration status
 * @param {'match'} [props.kind]    a live match reads "Live"
 * @param {{label: string, tone?: string, pulse?: boolean, title?: string}} [props.badge]
 * @param {string} [props.className]
 */
const StatusBadge = ({ status, kind, badge, className = '' }) => {
  const { label, tone = 'neutral', pulse = false, title } = badge || statusBadge(status, { kind });
  return (
    <span className={['tone-badge', `tone-badge--${tone}`, className].filter(Boolean).join(' ')} title={title}>
      {pulse && <span className="tone-badge__dot" aria-hidden="true" />}
      {label}
    </span>
  );
};

export default StatusBadge;
